import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import { getEnumValues } from '../../../services/common/miscUtils';
import Yup from '../../../services/common/validation';
import { EmploymentStatusEnum } from '../../../types/employmentStatusEnum';
import { OccupationEnum } from '../../../types/occupationEnum';
import { EmploymentDetailsFormModel_MX } from './formModel';

export const getValidationSchema = (): ObjectSchema<EmploymentDetailsFormModel_MX> => {
  return Yup.object({
    employmentStatus: Yup.string().required(t('validation:required')).oneOf(getEnumValues(EmploymentStatusEnum)),
    occupation: Yup.string().required(t('validation:required')).oneOf(getEnumValues(OccupationEnum)),
    occupationNotes: Yup.string().notRequired(),
    employer: Yup.string().required(t('validation:required')),
    addressLine1: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .required(t('validation:required')),
    addressLine2: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .notRequired(),
    addressLine3: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .notRequired(),
    eirCode: Yup.string().eirCode(t('validation:invalidEircode')).required(t('validation:required')),
    town: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .required(t('validation:required')),
    county: Yup.string().required(t('validation:required')),
    timeWithEmployerFrom: Yup.string().requiredWithMsg(),
    timeWithEmployerTo: Yup.string().requiredWithMsg(),
    netMonthlyIncome: Yup.number().requiredWithMsg().validateNumber(16, 2),
    netOtherMonthlyIncome: Yup.number().requiredWithMsg().validateNumber(16, 2),
  });
};
